import * as Yup from 'yup';

import { VALIDATIONS_ERROR } from '~constants/validationsError';

export const FIELDS_NAME = {
  NAME: 'name',
} as const;

export const initialValues = {
  [FIELDS_NAME.NAME]: '',
};

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.NAME]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
});
